import multiRequest from '../shared/multiRequest';

const getBalance = () => {
  return multiRequest([
    {
      url: 'customer/balance-details',
      method: 'GET',
    },
  ]);
};

const changeRecurring = (code, action) => {
  if (action === 1) {
    return multiRequest([
      {
        url: `customer/recurring-plan/${code}/reactivate`,
        method: 'PUT',
      },
    ]);
  }

  return multiRequest([
    {
      url: `customer/recurring-plan/${code}`,
      method: 'PUT',
      data: {
        action, // activar y 2 desactiva
      },
    },
  ]);
};

const HomeService = {
  getBalance,
  changeRecurring,
};

export default HomeService;
